 // ARCHIVO AUTO-GENERADO. LOS CAMBIOS SE DESTRUIRÁN.

import {ProcedenciaIds} from './Procedencia'
import {Tables} from './Tables'
import {Align} from 'sopix/db/db-types'
import {tableEditors} from 'sopix/db/TableEditors'
import {SimpleEditor} from 'sopix/db/dbEditor'

export const ProcedenciaEdt = Object.freeze({
    idProcedencia : new SimpleEditor(ProcedenciaIds.idProcedencia, 11, 11),
    procedencia : new SimpleEditor(ProcedenciaIds.procedencia, 15, 10),
})

tableEditors[Tables.Procedencia] = ProcedenciaEdt
